import { render, staticRenderFns } from "./EstadoMulta.vue?vue&type=template&id=36fb5e4d&scoped=true"
import script from "./EstadoMulta.vue?vue&type=script&lang=js"
export * from "./EstadoMulta.vue?vue&type=script&lang=js"
import style0 from "./EstadoMulta.vue?vue&type=style&index=0&id=36fb5e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb5e4d",
  null
  
)

export default component.exports